export const WHISPER_CONFIG = {
  websocketUrl: import.meta.env.VITE_WHISPER_WS_URL,

  restApiUrl: import.meta.env.VITE_WHISPER_REST_URL,

  /**
   * NEVER set above 30 s (30000): the Whisper GPU worker returns no text for a
   * chunk over 30 s, and the API stores an empty transcript for it.
   */
  chunkDurationMs:
    Number(import.meta.env.VITE_WHISPER_CHUNK_DURATION_MS) || 12000,

  maxReconnectAttempts: 3,
  reconnectDelayMs: 1000,

  uploadTimeoutMs: 30000,
  maxChunkSizeBytes: 1024 * 1024,
  // Server rejects chunks under 1024 bytes with HTTP 400.
  minChunkSizeBytes: 1024,

  audioConfig: {
    channelCount: 1,
    sampleRate: 48000,
    echoCancellation: true,
    noiseSuppression: true,
    audioBitsPerSecond: 128000,
  },
} as const;
